import { type BigQueryJobName } from './job-names';
import {
  IAccountCreditWriteTopicData,
  IAppointmentWriteTopicData,
  IBrandWriteTopicData,
  IContactWriteTopicData,
  IInvoiceWriteTopicData,
  ILabJobReceivedTopicData,
  ILabJobStatusUpdateTopicData,
  ILabJobWriteTopicData,
  ILabWriteTopicData,
  IPatientInteractionWriteTopicData,
  IPatientWriteTopicData,
  IPaymentPlanStatusUpdateTopicData,
  IPaymentPlanWriteTopicData,
  IPracticeWriteTopicData,
  IScheduleSummaryWriteTopicData,
  ISchedulingEventReasonWriteTopicData,
  ISchedulingEventWriteTopicData,
  IStafferWriteTopicData,
  ITaskCompletedTopicData,
  ITaskStatusUpdateTopicData,
  ITaskWriteTopicData,
  ITeamWriteTopicData,
  ITransactionWriteTopicData,
  ITreatmentPlanCompletedTopicData,
  ITreatmentPlanStatusUpdateTopicData,
  ITreatmentPlanWriteTopicData,
  ITreatmentStepWriteTopicData,
} from './topic-data/topic-data';

export interface IBigQueryJob<JobType, Data> {
  jobName: JobType;
  data: Data;
}

export interface IBigQueryJobContext {
  eventId: string;
}

export type WithContext<T> = T & { context: IBigQueryJobContext };

export type BigQueryJob =
  | IBigQueryJob<
      BigQueryJobName.AccountCreditWrite,
      IAccountCreditWriteTopicData
    >
  | IBigQueryJob<BigQueryJobName.AppointmentWrite, IAppointmentWriteTopicData>
  | IBigQueryJob<BigQueryJobName.BrandWrite, IBrandWriteTopicData>
  | IBigQueryJob<BigQueryJobName.ContactWrite, IContactWriteTopicData>
  | IBigQueryJob<BigQueryJobName.InvoiceWrite, IInvoiceWriteTopicData>
  | IBigQueryJob<BigQueryJobName.TransactionWrite, ITransactionWriteTopicData>
  | IBigQueryJob<BigQueryJobName.LabWrite, ILabWriteTopicData>
  | IBigQueryJob<BigQueryJobName.LabJobWrite, ILabJobWriteTopicData>
  | IBigQueryJob<
      BigQueryJobName.LabJobStatusUpdate,
      ILabJobStatusUpdateTopicData
    >
  | IBigQueryJob<BigQueryJobName.LabJobReceived, ILabJobReceivedTopicData>
  | IBigQueryJob<BigQueryJobName.PatientWrite, IPatientWriteTopicData>
  | IBigQueryJob<
      BigQueryJobName.PatientInteractionWrite,
      IPatientInteractionWriteTopicData
    >
  | IBigQueryJob<BigQueryJobName.PaymentPlanWrite, IPaymentPlanWriteTopicData>
  | IBigQueryJob<
      BigQueryJobName.PaymentPlanStatusUpdate,
      IPaymentPlanStatusUpdateTopicData
    >
  | IBigQueryJob<BigQueryJobName.PracticeWrite, IPracticeWriteTopicData>
  | IBigQueryJob<BigQueryJobName.StafferWrite, IStafferWriteTopicData>
  | IBigQueryJob<BigQueryJobName.TaskWrite, ITaskWriteTopicData>
  | IBigQueryJob<BigQueryJobName.TaskCompleted, ITaskCompletedTopicData>
  | IBigQueryJob<BigQueryJobName.TaskEvent, ITaskStatusUpdateTopicData>
  | IBigQueryJob<BigQueryJobName.TeamWrite, ITeamWriteTopicData>
  | IBigQueryJob<
      BigQueryJobName.TreatmentPlanWrite,
      ITreatmentPlanWriteTopicData
    >
  | IBigQueryJob<
      BigQueryJobName.TreatmentPlanCompleted,
      ITreatmentPlanCompletedTopicData
    >
  | IBigQueryJob<
      BigQueryJobName.TreatmentPlanStatusUpdate,
      ITreatmentPlanStatusUpdateTopicData
    >
  | IBigQueryJob<
      BigQueryJobName.ScheduleSummaryWrite,
      IScheduleSummaryWriteTopicData
    >
  | IBigQueryJob<
      BigQueryJobName.TreatmentStepWrite,
      ITreatmentStepWriteTopicData
    >
  | IBigQueryJob<
      BigQueryJobName.SchedulingEventWrite,
      ISchedulingEventWriteTopicData
    >
  | IBigQueryJob<
      BigQueryJobName.SchedulingEventReasonWrite,
      ISchedulingEventReasonWriteTopicData
    >;
